export default "__VITE_ASSET__I1SS3UO2__"